import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import WfsLogService from "../services/WfsLogService";

const useWfsLogService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new WfsLogService(client);
  }, [client]);

  return service;
};

export default useWfsLogService;
